"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SocialIconsIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.198 2.384c0-.625.506-1.132 1.131-1.132h3.348c.624 0 1.131.507 1.131 1.132V5.73c0 .625-.507 1.131-1.131 1.131H2.329A1.132 1.132 0 011.198 5.73V2.384zM10.701.92a1.132 1.132 0 011.6 0l2.368 2.367a1.132 1.132 0 010 1.6l-2.367 2.368a1.132 1.132 0 01-1.6 0L8.334 4.888a1.132 1.132 0 010-1.6L10.7.92zm-9.503 9.384a1.13 1.13 0 011.131-1.131h3.348c.624 0 1.131.506 1.131 1.131v3.348c0 .625-.507 1.131-1.131 1.131H2.329a1.132 1.132 0 01-1.131-1.131v-3.348zm7.588 0c0-.625.507-1.131 1.131-1.131h3.348a1.13 1.13 0 011.131 1.131v3.348a1.13 1.13 0 01-1.131 1.131H9.917a1.132 1.132 0 01-1.131-1.131v-3.348z"
  })))
});
SocialIconsIcon.displayName = 'SocialIconsIcon';
var _default = exports.default = SocialIconsIcon;